import SalesDashboard from './SalesDashboard'
export default SalesDashboard
